/**
 * AppDownloadButton
 * Smart CTA: adapts to visitor platform and configured store URLs.
 */
import { APP_CONFIG, detectPlatform, getAppCtaHref } from '../../config/appConfig';
import styles from './AppDownloadButton.module.css';
import { ANALYTICS_EVENTS, trackEvent } from '../../analytics';

const trackStore = (destination, source) => trackEvent(
    destination === 'app_store' ? ANALYTICS_EVENTS.APP_STORE_CLICKED : ANALYTICS_EVENTS.PLAY_STORE_CLICKED,
    { source, destination }
);

function AppDownloadButton({
                               source = 'unknown',
                               /** Override the default label */
                               labelOverride,
                               className = '',
                               size = 'md', // 'sm' | 'md' | 'lg'
                           }) {
    const platform = detectPlatform();
    const ctaHref = getAppCtaHref();

    if (platform === 'desktop') {
        // Show both store buttons when URLs exist
        const hasBoth = APP_CONFIG.iosUrl && APP_CONFIG.androidUrl;
        if (hasBoth) {
            return (
                <div className={styles.storePair}>
                    <a href={APP_CONFIG.iosUrl} onClick={() => trackStore('app_store', source)} target="_blank" rel="noopener noreferrer" className={`${styles.storeBtn} ${styles[size]} ${className}`}>
                        <span className={styles.storeIcon}>🍎</span> App Store
                    </a>
                    <a href={APP_CONFIG.androidUrl} onClick={() => trackStore('play_store', source)} target="_blank" rel="noopener noreferrer" className={`${styles.storeBtn} ${styles[size]} ${className}`}>
                        <span className={styles.storeIcon}>▶</span> Google Play
                    </a>
                    {/* TODO: optionally render a QR code utility here if one exists */}
                </div>
            );
        }
    }

    // Single-platform or only one URL available
    const href = ctaHref;
    const label = labelOverride || 'Get the App';

    if (!href) return null;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.btn} ${styles[size]} ${className}`}
            onClick={() => trackStore(href === APP_CONFIG.iosUrl ? 'app_store' : 'play_store', source)}
        >
            <span className={styles.icon}>📱</span>
            {label}
        </a>
    );
}

export default AppDownloadButton;
